// extracted by mini-css-extract-plugin
export default {"Container":"Loading__Container__l8ouW","LoadingIcon":"Loading__LoadingIcon__1SNH-","LoadingText":"Loading__LoadingText__39bIM"};